import { render, staticRenderFns } from "./MethodBinance.vue?vue&type=template&id=f8f56234&scoped=true&"
import script from "./MethodBinance.vue?vue&type=script&lang=js&"
export * from "./MethodBinance.vue?vue&type=script&lang=js&"
import style0 from "./MethodBinance.vue?vue&type=style&index=0&id=f8f56234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f56234",
  null
  
)

export default component.exports